import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import './WpoDashboard.css';
import FullPageSpinner from 'components/common/full-page-spinner';
import { getGrns, searchs } from 'services/stock-location/wpoDashboardService';
import WpoDashboardTable from './WpoDashboardTable';
import WpoDashboardFilter from './WpoDashboardFilter';
import { usePaginationBe } from 'hooks/useBeHandle';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import { statusOptions } from './WpoDashboardType';
import GRNsModal from './GRNs/GRNsModal';
import BookingInModal from './BookingIn/BookingInModal';

export default function WpoDashboard() {
  const defaultRQ = new BaseTableRQ(1, 20);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [paging, setPaging] = useState({ ...defaultRQ });

  const [showGRNs, setShowGRNs] = useState(false);
  const [grnData, setGrnData] = useState([]);
  const [selectedWpo, setSelectedWpo] = useState(null);
  const openGRNsModal = wpoNo => {
    setSelectedWpo(wpoNo);
    getGrns(wpoNo).then(x => {
      setGrnData(x.data);
      setShowGRNs(true);
    });
  };

  const [showBookingIn, setShowBookingIn] = useState(false);
  const [selectedWpoRow, setSelectedWpoRow] = useState(null);

  const openBookingInModal = (wpoRow) => {
    setSelectedWpoRow(wpoRow);
    setShowBookingIn(true);
  };

  const now = new Date();
  const firstDay3MonthsAgo = new Date(now.getFullYear(), now.getMonth() - 3, 1);

  const [filter, setFilter] = useState({
    supplierId: null,
    keyword: '',
    statuses: [],
    orderedFrom: firstDay3MonthsAgo,
    orderedTo:  now,
    dueFrom: undefined,
    dueTo: undefined
  });
  const [exportParam, setExportParam] = useState({});
  const [colSort, setColSort] = useState(undefined);

  const handleFilterChange = (field, value) => {
    setFilter(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const toApiDate = date => (date ? date.toISOString().split('T')[0] : null);
  const buildSearchRQ = pagingRq => {
    const rq = {
      ...pagingRq,
      supplierId: filter.supplierId,
      keyword: filter.keyword,
      statuses: filter.statuses?.map(x => x.value),

      orderedFrom: toApiDate(filter.orderedFrom),
      orderedTo: toApiDate(filter.orderedTo),

      dueFrom: toApiDate(filter.dueFrom),
      dueTo: toApiDate(filter.dueTo)
    };

    return Object.fromEntries(
      Object.entries(rq).filter(
        ([, v]) => v !== null && v !== undefined && v !== ''
      )
    );
  };
  const loadSearch = pagingRq => {
    setIsLoading(true);
    const rq = buildSearchRQ(pagingRq);
    console.log(rq);
    searchs(rq)
      .then(res => {
        if (!res) return;
        setTotal(res.total);
        setData(res.items);
        const cl = {
          ...pagingRq,
          sortBy: pagingRq.sortBy,
          desc: pagingRq.desc,
          isBeSortedDesc: pagingRq.desc,
          isBeSorted: pagingRq.sortBy !== undefined && pagingRq.sortBy !== ''
        };

        setExportParam(cl);
        setColSort(cl);
        setPaging(cl);
        setFilter(cl);
      })
      .catch(err => {
        console.error('❌ load WPO error:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSearch = () => {
    loadSearch({ ...paging, ...filter, pageNum: 1 });
  };

  const { gotoPage, nextPage, previousPage, handleSort } = usePaginationBe(
    paging,
    total,
    loadSearch,
    filter,
    setFilter
  );

  return (
    <div className="wpo-page">
      <FullPageSpinner show={isLoading} quantity={3} variant="success" />
      <PageHeader
        title="WPO Dashboard"
        description="Search and filter WPOs by supplier, status and dates."
        className="mb-3"
      />

      <WpoDashboardFilter
        filter={filter}
        handleChange={handleFilterChange}
        handleSubmit={handleSearch}
        statusOptions={statusOptions}
      />

      <Card>
        <Card.Body>
          <WpoDashboardTable
            data={data}
            exportParam={exportParam}
            paging={{ ...paging, ...filter }}
            total={total}
            nextPage={nextPage}
            previousPage={previousPage}
            gotoPage={gotoPage}
            colSort={colSort}
            handleSort={handleSort}
            openGRNsModal={openGRNsModal}
            openBookingInModal={openBookingInModal}
          />

        </Card.Body>
      </Card>
      <GRNsModal
        isShow={showGRNs}
        handleClose={() => setShowGRNs(false)}
        wpoNo={selectedWpo}
        data={grnData}
      />
      <BookingInModal
        isShow={showBookingIn}
        handleClose={() => setShowBookingIn(false)}
        wpoData={selectedWpoRow}
      />
    </div>
  );
}
